/**
 * @type module
 * Moduł główny - zapisuje odwołanie do elementu lokalizatora w $self,
 * inicjalizuje współpracujące moduły oraz nasłuchiwanie zdarzeń
 */
app.service( 'shopLocator', function( shopLocatorMap, shopLocatorFilters, shopLocatorSearch ) {
	var $self;

	var filterClick = function( index ) {
		var index = ( typeof index === 'string' ) ? index : $(this).data('index');
		shopLocatorFilters.clear();
		shopLocatorFilters.set( index );
		shopLocatorSearch.clear( true );
		shopLocatorMap.show( index );
	};

	var filterChange = function() {
		var index = $(this).data('index');

		if( $(this).is(':checked') ) {
			shopLocatorFilters.set( index );
		} else {
			shopLocatorFilters.clear( index );
			shopLocatorSearch.updateSearchList();
		}
		if( !shopLocatorFilters.getSelected().length ) {
			shopLocatorSearch.clear( true );
		}
		shopLocatorMap.show( index, function() {
			shopLocatorSearch.updateSearchList();
		} );
	};

	function setEvents() {
		$self.on( 'click', '.js-delivery-option', filterClick );
		$self.on( 'change', '.js-filter-menu', filterChange );
		$self.on( 'keydown keyup', '.search-input', function( e ) {
			if( e.keyCode ===  40 || e.keyCode === 38 || e.keyCode === 13 ) {
				if( e.type === 'keydown' ) {
					shopLocatorSearch.handleSelection( e.keyCode );
				}
			} else {
				if( e.type === 'keyup' ) {
					shopLocatorSearch.findCities( $(this).val() );
				}
			}
		} );
		$self.on( 'click', '.js-city', function() {
			shopLocatorSearch.findShops( $(this).html() );
		} );
		$self.on( 'click', '.js-place', function() {
			var code = $(this).addClass('active').data('code');
			$('.js-place').not( $(this) ).removeClass('active');
			shopLocatorMap.zoom( String(code) );
		} );
	}

	function setElements() {
			$self = $('.shop-locator');
	}

	function init() {
		setElements();
		setEvents();
		shopLocatorMap.init( $self );
		shopLocatorFilters.init( $self );
		shopLocatorSearch.init( $self );
		filterClick.call(null, 'shop');
	}

	return {
		init: init
	};
});
